// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block; 
}
 
:host ::ng-deep .lsr-link {
  font-weight: 600;
  text-decoration: underline;
  color: #4b0082;
  /* purple */
  display: flex;
  justify-content: flex-end;
  padding: 12px 20px;
} 
 
:host ::ng-deep h1 {
  font-size: 60px;
  line-height: 1.2;
  font-weight: 400;
}

:host ::ng-deep h2 {
  margin-top: 36px;
  font-size: 30px;
  line-height: 1.2;
  font-weight: 600;
  color: var(--color-purple);
}

:host ::ng-deep .header {
  display: inline-block;
  margin-top: 30px;
  font-size: 18px;
  line-height: 1.2;
  font-weight: 600;
  color: var(--color-purple);
}

:host ::ng-deep p,
:host ::ng-deep ul,
:host ::ng-deep ol {
  font-size: 16px;
  line-height: 1.18;
}

:host ::ng-deep a {
  color: var(--color-green);
}

:host ::ng-deep ul,
:host ::ng-deep ol {
  padding-left: 24px;
}

:host li + li {
  margin-top: 8px;
}

:host  .hero--inner {
  min-height: 200px;
  position: relative;
  padding-right: 0;
}

:host .hero--inner .hero__content,
:host .hero--inner .content {
  max-width: 620px;
  padding: 70px 0 20px 60px;
}

:host .hero--inner h1 {
  font-size: 36px;
  line-height: 1.12;
}
::ng-deep .numericText
  {
    font-variant-numeric: lining-nums tabular-nums;
    font-feature-settings: "lnum" 1, "tnum" 1;
  }
:host .hero--inner .hero__image,
:host .hero--inner > img {
 position: absolute;
  z-index: 1;
  right: 84px;
  top: 50%;
  width: 494px;
  height: 100%;
  max-width: none;
  object-fit: cover;
  object-position: right top;
  pointer-events: none;
}

:host .privacy-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  
  padding: 40px var(--space-page-x) 60px;
}

@media (max-width: 1024px) {
  :host h1 {
    font-size: 48px;
    line-height: 1.12;
  }
}

@media (max-width: 767px) {
  :host h1 {
    font-size: 38px;
  }

  :host h2 {
    font-size: 26px;
  }

  :host p,
  :host ul,
  :host ol {
    font-size: 16px;
    line-height: 1.35;
  }

  :host .hero--inner .hero__content,
  :host .hero--inner .content {
    padding: 40px 20px;
  }

  :host .hero--inner .hero__image,
  :host .hero--inner > img {
    right: -40px;
    width: 70%;
  }
 
}
`, "",{"version":3,"sources":["webpack://./src/app/LSR/participant/lsr_privacy/lsr_privacy.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;;EAGE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;IAEI,8CAA8C;IAC9C,yCAAyC;EAC3C;AACF;;CAEC,kBAAkB;EACjB,UAAU;EACV,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;;EAEtB,sCAAsC;AACxC;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,YAAY;IACZ,UAAU;EACZ;;AAEF","sourcesContent":[":host {\r\n  display: block; \r\n}\r\n \r\n:host ::ng-deep .lsr-link {\r\n  font-weight: 600;\r\n  text-decoration: underline;\r\n  color: #4b0082;\r\n  /* purple */\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding: 12px 20px;\r\n} \r\n \r\n:host ::ng-deep h1 {\r\n  font-size: 60px;\r\n  line-height: 1.2;\r\n  font-weight: 400;\r\n}\r\n\r\n:host ::ng-deep h2 {\r\n  margin-top: 36px;\r\n  font-size: 30px;\r\n  line-height: 1.2;\r\n  font-weight: 600;\r\n  color: var(--color-purple);\r\n}\r\n\r\n:host ::ng-deep .header {\r\n  display: inline-block;\r\n  margin-top: 30px;\r\n  font-size: 18px;\r\n  line-height: 1.2;\r\n  font-weight: 600;\r\n  color: var(--color-purple);\r\n}\r\n\r\n:host ::ng-deep p,\r\n:host ::ng-deep ul,\r\n:host ::ng-deep ol {\r\n  font-size: 16px;\r\n  line-height: 1.18;\r\n}\r\n\r\n:host ::ng-deep a {\r\n  color: var(--color-green);\r\n}\r\n\r\n:host ::ng-deep ul,\r\n:host ::ng-deep ol {\r\n  padding-left: 24px;\r\n}\r\n\r\n:host li + li {\r\n  margin-top: 8px;\r\n}\r\n\r\n:host  .hero--inner {\r\n  min-height: 200px;\r\n  position: relative;\r\n  padding-right: 0;\r\n}\r\n\r\n:host .hero--inner .hero__content,\r\n:host .hero--inner .content {\r\n  max-width: 620px;\r\n  padding: 70px 0 20px 60px;\r\n}\r\n\r\n:host .hero--inner h1 {\r\n  font-size: 36px;\r\n  line-height: 1.12;\r\n}\r\n::ng-deep .numericText\r\n  {\r\n    font-variant-numeric: lining-nums tabular-nums;\r\n    font-feature-settings: \"lnum\" 1, \"tnum\" 1;\r\n  }\r\n:host .hero--inner .hero__image,\r\n:host .hero--inner > img {\r\n position: absolute;\r\n  z-index: 1;\r\n  right: 84px;\r\n  top: 50%;\r\n  width: 494px;\r\n  height: 100%;\r\n  max-width: none;\r\n  object-fit: cover;\r\n  object-position: right top;\r\n  pointer-events: none;\r\n}\r\n\r\n:host .privacy-content {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  \r\n  padding: 40px var(--space-page-x) 60px;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  :host h1 {\r\n    font-size: 48px;\r\n    line-height: 1.12;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  :host h1 {\r\n    font-size: 38px;\r\n  }\r\n\r\n  :host h2 {\r\n    font-size: 26px;\r\n  }\r\n\r\n  :host p,\r\n  :host ul,\r\n  :host ol {\r\n    font-size: 16px;\r\n    line-height: 1.35;\r\n  }\r\n\r\n  :host .hero--inner .hero__content,\r\n  :host .hero--inner .content {\r\n    padding: 40px 20px;\r\n  }\r\n\r\n  :host .hero--inner .hero__image,\r\n  :host .hero--inner > img {\r\n    right: -40px;\r\n    width: 70%;\r\n  }\r\n \r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
